import { z } from 'zod';

const _booleanStats = ['has_stats'] as const;

const _stringStats = ['last_modified'] as const;

export type BooleanStatId = (typeof _booleanStats)[number];
export type StringStatId = (typeof _stringStats)[number];

export type ResourceStat =
  | {
      id?: string | null;
      label?: string | null;
      value?: any;
      description?: string | null;
      include?: boolean | null;
    }
  | undefined
  | null;

export const getBooleanStat = (
  stats: ResourceStat[] | null | undefined,
  id: BooleanStatId,
): boolean | undefined => {
  const parsedStat = z
    .boolean()
    .safeParse(stats?.find((stat) => stat?.id === id)?.value);
  return parsedStat.success ? parsedStat.data : undefined;
};

export const getStringStat = (
  stats: ResourceStat[] | null | undefined,
  id: StringStatId,
): string | undefined => {
  const parsedStat = z
    .string()
    .safeParse(stats?.find((stat) => stat?.id === id)?.value);
  return parsedStat.success ? parsedStat.data : undefined;
};
